const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Horas de la escuela',
        },
      },
    },
  },
};

export default layout;
